import { NavLink } from 'react-router'
import { FiArrowRight } from 'react-icons/fi'
import { Container, Reveal, HoverText } from '@/components/common'
import { ROUTES } from '@/constants/routes'
import { partners } from '@/constants/partners'

export const Partners = () => {
  return (
    <section className="bg-white py-24 text-ibon-dark lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.05] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Stronger <span className="text-ibon-dark/30">together</span>
            </h2>
          </Reveal>
          <Reveal variant="up" delay={200}>
            <p className="mt-8 text-lg leading-relaxed text-text-muted">
              Meaningful and lasting impact is achieved through collaboration. By working alongside
              educational institutions, government agencies, development partners, businesses, and
              community organisations, we expand opportunities and create positive change across
              Africa and the Caribbean.
            </p>
          </Reveal>
        </div>

        <Reveal variant="up" delay={120}>
          <div className="mt-16 grid grid-cols-2 overflow-hidden border-t border-l border-border sm:grid-cols-3 lg:grid-cols-4">
            {partners.map(({ name, Icon }) => (
              <div
                key={name}
                className="group relative flex h-40 flex-col items-center justify-center gap-4 border-r border-b border-border bg-white px-6 text-center transition-colors duration-300 hover:bg-surface"
              >
                <span className="absolute right-4 top-4 size-1.5 rounded-full bg-border transition-colors duration-300 group-hover:bg-ibon-sky" />
                <Icon className="text-3xl text-ibon-dark transition-transform duration-300 group-hover:scale-110 group-hover:text-ibon-sky" />
                <span className="text-xs font-semibold uppercase tracking-[0.15em] text-text-muted transition-colors duration-300 group-hover:text-ibon-dark">
                  {name}
                </span>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal variant="up" delay={120}>
          <NavLink
            to={ROUTES.PARTNER}
            className="group mt-12 inline-flex items-center gap-2 rounded-full bg-ibon-dark px-8 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-ibon-navy"
          >
            <HoverText text="Partner With Us" />
            <FiArrowRight
              className="transition-transform duration-300 group-hover:translate-x-1"
              size={15}
            />
          </NavLink>
        </Reveal>
      </Container>
    </section>
  )
}
